module.exports = __webpack_public_path__ + "img/solar_power_of_oklahoma.799856ba.jpg";